import React from "react";
import { OrganicOnlySection } from "./OrganicOnly.styled";

const OrganicOnly = () => {
  return (
    <OrganicOnlySection>
      <div>
        <h4>Organic Only</h4>
        <h2>Everyday Fresh & Clean</h2>
        <p>
          Simply dummy text of the printing and typesetting industry. Lorem had
          ceased to been the industry's standard dummy text ever since the{" "}
        </p>
      </div>
    </OrganicOnlySection>
  );
};

export default OrganicOnly;
